export const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://azalearidgehome.com';
export const META_PIXEL_ID = import.meta.env.VITE_META_PIXEL_ID || '1661448335689218';
export const GA4_MEASUREMENT_ID = import.meta.env.VITE_GA4_MEASUREMENT_ID || '';
export const CONTACT_NAME = import.meta.env.VITE_CONTACT_NAME || 'Fanny Torres';
export const CONTACT_PHONE = import.meta.env.VITE_CONTACT_PHONE || '+19802023043';
export const CONTACT_EMAIL = import.meta.env.VITE_CONTACT_EMAIL || 'fannytorres@kw.com';

export const property = {
  address: '3649 Azalea Ridge Dr',
  city: 'Mount Holly',
  state: 'NC',
  zip: '28120',
  price: 400000,
  bedrooms: 3,
  bathrooms: 2,
  squareFeet: 1644,
  lotAcres: 0.18,
  yearBuilt: 2023,
  hoaMonthly: 69,
  hoaQuarterly: 206,
  brokerage: 'Keller Williams Ballantyne Area',
  mls: '4371409',
  culDeSac: true,
  marketingFeatures: ['Cul-de-Sac Location'],
  images: [
    {
      id: 'azalea-exterior-01',
      src: 'https://media-manager-c.questera.ai/greta-media/93693806e52d557505bcda151baedfc511d2a8846f04584b1cb3f9d6077d8cb7ad67425a4311fb1bee70aa0e3387aa1d/images/aW1hZ2UvanBlZw==/07bf28fa4540456b677ec393de41a5bd.jpg',
      alt: 'Front exterior of 3649 Azalea Ridge Dr with blue-gray and gray siding, stone accents, black front door and two-car garage',
      caption: 'Front exterior',
      category: 'Exterior',
      quality: 'A',
      potentialUses: ['Facebook Feed', 'Instagram Feed', 'Meta carousel', 'Landing-page hero', 'Landing-page gallery'],
    },
    {
      id: 'azalea-open-layout-01',
      src: 'https://media-manager-c.questera.ai/greta-media/93693806e52d557505bcda151baedfc511d2a8846f04584b1cb3f9d6077d8cb7ad67425a4311fb1bee70aa0e3387aa1d/images/aW1hZ2UvcG5n/31b15009230a7c36ac1d72c49f2cd4f4.PNG',
      alt: 'Open kitchen with granite island, stainless steel appliances and open living area',
      caption: 'Open living area',
      category: 'Open Floor Plan',
      quality: 'B',
      potentialUses: ['Facebook Feed', 'Instagram Feed', 'Meta carousel', 'Landing-page gallery', 'Property feature section'],
    },
    {
      id: 'azalea-kitchen-01',
      src: 'https://media-manager-c.questera.ai/greta-media/93693806e52d557505bcda151baedfc511d2a8846f04584b1cb3f9d6077d8cb7ad67425a4311fb1bee70aa0e3387aa1d/images/aW1hZ2UvcG5n/f4bae1b3954aeb97d0d46907c2264df1.PNG',
      alt: 'Kitchen with granite island and stainless steel refrigerator opening to an empty living area with wood-look flooring',
      caption: 'Kitchen and living area',
      category: 'Kitchen',
      quality: 'A',
      potentialUses: ['Facebook Feed', 'Instagram Feed', 'Meta carousel', 'Landing-page gallery', 'Property feature section'],
    },
    {
      id: 'azalea-patio-01',
      src: 'https://media-manager-c.questera.ai/greta-media/93693806e52d557505bcda151baedfc511d2a8846f04584b1cb3f9d6077d8cb7ad67425a4311fb1bee70aa0e3387aa1d/images/aW1hZ2UvcG5n/6c7e2e3cdfa29227efd50852188a6865.PNG',
      alt: 'Covered concrete patio with sliding glass door',
      caption: 'Covered patio',
      category: 'Patio',
      quality: 'B',
      potentialUses: ['Meta carousel', 'Landing-page gallery', 'Property feature section'],
    },
    {
      id: 'azalea-living-room-01',
      src: 'https://media-manager-c.questera.ai/greta-media/93693806e52d557505bcda151baedfc511d2a8846f04584b1cb3f9d6077d8cb7ad67425a4311fb1bee70aa0e3387aa1d/images/aW1hZ2UvcG5n/f77c83f093b1d28501397d0673613726.PNG',
      alt: 'Living room with corner fireplace, wood-look flooring and hallway to the front door',
      caption: 'Living room',
      category: 'Living Room',
      quality: 'B',
      potentialUses: ['Facebook Feed', 'Meta carousel', 'Landing-page gallery', 'Property feature section'],
    },
    {
      id: 'azalea-living-room-02',
      src: 'https://media-manager-c.questera.ai/greta-media/93693806e52d557505bcda151baedfc511d2a8846f04584b1cb3f9d6077d8cb7ad67425a4311fb1bee70aa0e3387aa1d/images/aW1hZ2UvcG5n/6fd60942fbc276313b23fe61ed7cd5c5.PNG',
      alt: 'Living room with corner fireplace, large window and wood-look flooring',
      caption: 'Living room',
      category: 'Living Room',
      quality: 'B',
      potentialUses: ['Facebook Feed', 'Meta carousel', 'Landing-page gallery', 'Property feature section'],
    },
    {
      id: 'azalea-dining-area-01',
      src: 'https://media-manager-c.questera.ai/greta-media/93693806e52d557505bcda151baedfc511d2a8846f04584b1cb3f9d6077d8cb7ad67425a4311fb1bee70aa0e3387aa1d/images/aW1hZ2UvcG5n/3d16a2fcbc3d1b2b6416883c2cb355b4.PNG',
      alt: 'Empty dining area with large window with blinds, sliding glass door to the covered patio and wood-look flooring',
      caption: 'Dining area',
      category: 'Dining Area',
      quality: 'B',
      potentialUses: ['Instagram Feed', 'Meta carousel', 'Landing-page gallery', 'Property feature section'],
    },
    {
      id: 'azalea-dining-area-02',
      src: 'https://media-manager-c.questera.ai/greta-media/93693806e52d557505bcda151baedfc511d2a8846f04584b1cb3f9d6077d8cb7ad67425a4311fb1bee70aa0e3387aa1d/images/aW1hZ2UvcG5n/f6c030520acf498dbe5ffa9209e17356.PNG',
      alt: 'Kitchen with gray cabinets, granite counters and gas range, opening to a dining area with a window',
      caption: 'Kitchen',
      category: 'Kitchen',
      quality: 'C',
      potentialUses: ['Landing-page gallery'],
    },
    {
      id: 'azalea-primary-bedroom-01',
      src: 'https://media-manager-c.questera.ai/greta-media/93693806e52d557505bcda151baedfc511d2a8846f04584b1cb3f9d6077d8cb7ad67425a4311fb1bee70aa0e3387aa1d/images/aW1hZ2UvcG5n/aacc50da22750945ffd6c1d9de29877f.PNG',
      alt: 'Bedroom with carpet and large window with blinds',
      caption: 'Bedroom',
      category: 'Other',
      quality: 'B',
      potentialUses: ['Instagram Feed', 'Meta carousel', 'Landing-page gallery', 'Property feature section'],
    },
    {
      id: 'azalea-bedroom-02',
      src: 'https://media-manager-c.questera.ai/greta-media/93693806e52d557505bcda151baedfc511d2a8846f04584b1cb3f9d6077d8cb7ad67425a4311fb1bee70aa0e3387aa1d/images/aW1hZ2UvcG5n/9141136c72d9affebde384ed355ed847.PNG',
      alt: 'Bedroom with carpet, closet door and open door to the adjoining hallway',
      caption: 'Bedroom',
      category: 'Other',
      quality: 'B',
      potentialUses: ['Facebook Feed', 'Instagram Feed', 'Meta carousel', 'Landing-page gallery'],
    },
    {
      id: 'azalea-bathroom-01',
      src: 'https://media-manager-c.questera.ai/greta-media/93693806e52d557505bcda151baedfc511d2a8846f04584b1cb3f9d6077d8cb7ad67425a4311fb1bee70aa0e3387aa1d/images/aW1hZ2UvcG5n/68787b0a3d8dc5b70af2ba3de575467d.PNG',
      alt: 'Bathroom showing vanity, glass shower and bathtub',
      caption: 'Bathroom',
      category: 'Other',
      quality: 'B',
      potentialUses: ['Meta carousel', 'Landing-page gallery', 'Property feature section'],
    },
    {
      id: 'azalea-bathroom-02',
      src: 'https://media-manager-c.questera.ai/greta-media/93693806e52d557505bcda151baedfc511d2a8846f04584b1cb3f9d6077d8cb7ad67425a4311fb1bee70aa0e3387aa1d/images/aW1hZ2Uvd2VicA==/aee912306e7ca02bc2ac393863b7b699.webp',
      alt: 'Closer view of bathroom shower and bathtub',
      caption: 'Shower and bathtub',
      category: 'Other',
      quality: 'C',
      potentialUses: ['Landing-page gallery'],
    },
    {
      id: 'azalea-bathroom-03',
      src: 'https://media-manager-c.questera.ai/greta-media/93693806e52d557505bcda151baedfc511d2a8846f04584b1cb3f9d6077d8cb7ad67425a4311fb1bee70aa0e3387aa1d/images/aW1hZ2UvcG5n/67d435ee15a79d8240abef653132b140.PNG',
      alt: 'Bathroom double vanity with large mirror and tiled floor',
      caption: 'Bathroom vanity',
      category: 'Other',
      quality: 'C',
      potentialUses: ['Landing-page gallery', 'Property feature section'],
    },
    {
      id: 'azalea-bedroom-03',
      src: 'https://media-manager-c.questera.ai/greta-media/93693806e52d557505bcda151baedfc511d2a8846f04584b1cb3f9d6077d8cb7ad67425a4311fb1bee70aa0e3387aa1d/images/aW1hZ2UvcG5n/2db407c0bc7033bbd2b805917048da4a.PNG',
      alt: 'Bedroom with carpet, white baseboards and a window with blinds',
      caption: 'Bedroom',
      category: 'Other',
      quality: 'B',
      potentialUses: ['Instagram Feed', 'Meta carousel', 'Landing-page gallery'],
    },
    {
      id: 'azalea-bedroom-04',
      src: 'https://media-manager-c.questera.ai/greta-media/93693806e52d557505bcda151baedfc511d2a8846f04584b1cb3f9d6077d8cb7ad67425a4311fb1bee70aa0e3387aa1d/images/aW1hZ2UvcG5n/af676bd028c8426e23d3c5ba97d7d802.PNG',
      alt: 'Spacious bedroom with carpet and hallway leading to the bathroom',
      caption: 'Bedroom',
      category: 'Other',
      quality: 'B',
      potentialUses: ['Meta carousel', 'Landing-page gallery'],
    },
    {
      id: 'azalea-guest-bathroom-01',
      src: 'https://media-manager-c.questera.ai/greta-media/93693806e52d557505bcda151baedfc511d2a8846f04584b1cb3f9d6077d8cb7ad67425a4311fb1bee70aa0e3387aa1d/images/aW1hZ2UvcG5n/4f545f8c05db9ae6068d4ac9dbc99514.PNG',
      alt: 'Bathroom with tub and shower, vanity, mirror and toilet',
      caption: 'Bathroom',
      category: 'Guest Bathroom',
      quality: 'B',
      potentialUses: ['Meta carousel', 'Landing-page gallery'],
    },
    {
      id: 'azalea-entry-01',
      src: 'https://media-manager-c.questera.ai/greta-media/93693806e52d557505bcda151baedfc511d2a8846f04584b1cb3f9d6077d8cb7ad67425a4311fb1bee70aa0e3387aa1d/images/aW1hZ2Uvd2VicA==/e3e0118abb9bf479fbb7ad12f45a0140.webp',
      alt: 'Interior entry with glass-panel front door, wood-look flooring and console',
      caption: 'Entry',
      category: 'Front Entrance',
      quality: 'B',
      potentialUses: ['Instagram Feed', 'Meta carousel', 'Landing-page gallery', 'Property feature section'],
    },
    {
      id: 'azalea-laundry-01',
      src: 'https://media-manager-c.questera.ai/greta-media/93693806e52d557505bcda151baedfc511d2a8846f04584b1cb3f9d6077d8cb7ad67425a4311fb1bee70aa0e3387aa1d/images/aW1hZ2UvcG5n/f84f916e5d4d37861db92dcb964a258f.PNG',
      alt: 'Laundry area with washer and dryer hookups, overhead wire shelf and wood-look flooring',
      caption: 'Laundry area',
      category: 'Laundry',
      quality: 'C',
      potentialUses: ['Landing-page gallery'],
    },
  ],
  videoUrl: '',
  contactName: CONTACT_NAME,
  contactPhone: CONTACT_PHONE,
  contactEmail: CONTACT_EMAIL,
  metaPixelId: META_PIXEL_ID,
  ga4MeasurementId: GA4_MEASUREMENT_ID,
  siteUrl: SITE_URL,
  mapEmbedUrl: 'https://www.google.com/maps?q=3649%20Azalea%20Ridge%20Dr%2C%20Mount%20Holly%2C%20NC%2028120&output=embed',
  listingUrl: 'https://www.zillow.com/homedetails/3649-Azalea-Ridge-Dr-Mount-Holly-NC-28120/2060255207_zpid/',
};

export const propertyAddress = `${property.address}, ${property.city}, ${property.state} ${property.zip}`;